// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SKzkh","colBig":"styles_colBig__2erli","colSmall":"styles_colSmall__3K7IM","shopifyNameWrapper":"styles_shopifyNameWrapper__23YcW"};